import http from './utils';
import { mockPrefix, prefix } from './constants';

export const getFeedsStatsNew: (payload: any) => Promise<any> = payload => {
  return http({
    url: `${prefix}/feeds/stats`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

export const getFeedsKeywordNew: (payload: any) => Promise<any> = payload => {
  return http({
    url: `${prefix}/feeds/keyword`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
